function showPopUpEdit(evt){
    freshenContentPopup();
    evtTarget   = evt.target;
    let el = evtTarget.closest('.packs-bar__product');
    let idFormData = el.getAttribute('data-id-form');
    let btnDel = el.querySelector('.packs-bar__remove');
    btnDel = btnDel.getAttribute('id')
    let idVariants = el.querySelector('[name="properties[_idVariants]"]').value
    let dataForm = document.getElementById(idFormData).querySelector('.variants-product-form').textContent;
    let packImg = el.querySelector('.packs-bar__image ');
    packImg = packImg.getAttribute('src');

    dataForm = JSON.parse(dataForm);

    //let title = dataForm.title;
    // let description = dataForm.description;

    let variants = dataForm.variants;

    let popup = document.getElementById('popup-modal-pack');

    let img = popup.querySelector('#img-pack');
    const elImg = document.createElement('img');

    elImg.classList.add("popup-pack-image", "mf:tw-w-[168px]", "mf:tw-h-[168px]", "tw-w-[112px]", "tw-h-[112px]");
    elImg.setAttribute('src', packImg);
    img.append(elImg);

    //popup.querySelector('#title-pack').innerHTML = title;
    // popup.querySelector('#description-pack').innerHTML = description;

    let selectOption = popup.querySelector('#select-option');
    if(variants.length > 0) {
        for(let i=0; i<variants.length; i++) {
            let available = variants[i].available;
            var option = document.createElement("option");
            option.text = variants[i].title.replaceAll('/', ' ');
            option.value = variants[i].id;
            if(available != true) {
                option.setAttribute('disabled', true);
                option.classList.add('tw-line-through')
            }
            if(Number(variants[i].id) == Number(idVariants)) {
                option.setAttribute('selected', true)
            }
            selectOption.appendChild(option);
        }
    }

    let btnDeleteItem = popup.querySelector('#delete-item-pack');
    btnDeleteItem.onclick = function() {
        document.getElementById(btnDel).click();
        if(!popup.classList.contains('tw-hidden')) {
            popup.classList.add('tw-hidden');
        }
    };

    let btnConfirm = popup.querySelector('#btnConfirm');
    btnConfirm.onclick = function () {
        let variantsId = selectOption.value;
        el.querySelector('[name="properties[_idVariants]"]').value = variantsId;
        if(!popup.classList.contains('tw-hidden')) {
            popup.classList.add('tw-hidden');
        }
    }

    if(popup.classList.contains('tw-hidden')) {
        popup.classList.remove('tw-hidden');
    }
}

function freshenContentPopup() {
    let popup = document.getElementById('popup-modal-pack');
    popup.querySelector('#img-pack').innerHTML = null;
    popup.querySelector('#title-pack').innerHTML = '';
    popup.querySelector('#description-pack').innerHTML = '';
    popup.querySelector('#select-option').innerHTML = '';
    popup.querySelector('#delete-item-pack').onclick = null;
    popup.querySelector('#btnConfirm').onclick = null;
}

function closePopUp() {
    let popup = document.getElementById('popup-modal-pack');
    if(!popup.classList.contains('tw-hidden')) {
        popup.classList.add('tw-hidden')
    }
    freshenContentPopup();
}
